import { render, staticRenderFns } from "./BarPointNegatifConsultationsMDTChart.vue?vue&type=template&id=222f56d6&"
import script from "./BarPointNegatifConsultationsMDTChart.vue?vue&type=script&lang=ts&"
export * from "./BarPointNegatifConsultationsMDTChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports